import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMoment from 'vue-moment'
import moment from 'moment'
import 'moment/locale/es'
import { i18n } from '@/plugins/i18n/i18n'
import vuetify from '@/plugins/vuetify'
import store from '@/store'
import router from '@/router/router'
import App from '@/infrastructure/App.vue'
import VueTelInput from 'vue-tel-input'
import Toast, { POSITION } from 'vue-toastification'
import LottieAnimation from 'lottie-web-vue'
import VueCroppie from 'vue-croppie'
import VueGtm from '@gtm-support/vue2-gtm'
import './assets/css/vue-toastification/index.scss'
import 'vue-tel-input/dist/vue-tel-input.css'
import './input.scss'
import 'regenerator-runtime'
import * as VueGoogleMaps from 'vue2-google-maps'
import interceptorSetup from '@/utils/interceptor'
import VueYoutube from 'vue-youtube'
import '@/modules/conversations/infrastructure/ui/styles/Mentionable.scss'
import 'vuetify/dist/vuetify.min.css'
import VueCompositionAPI from '@vue/composition-api'

Vue.use(VueCompositionAPI)
Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM_CONTAINER_ID,
  enabled: false,
  trackOnNextTick: false
})

Vue.use(VueRouter)

Vue.use(VueMoment, { moment })
Vue.use(VueTelInput)
Vue.use(Toast, {
  position: POSITION.BOTTOM_RIGHT,
  containerClassName: 'custom-toast',
  icon: false
})
Vue.use(LottieAnimation)

// Vue.use(OneSignalVue)

Vue.use(VueCroppie)

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLEMAPS,
    libraries: 'places'
  },
  installComponents: true
})

Vue.use(VueYoutube)

interceptorSetup(store, router, i18n)
Vue.config.productionTip = false

new Vue({
  i18n,
  render: h => h(App),
  store,
  vuetify,
  router,
  beforeCreate () {
    this.$store.commit('initialiseStore')
  }
}).$mount('#app')

window.addEventListener('updateUserStorage--kbV6', (e: any) => {
  console.log('EVENT UPDATE USER STORAGE--kbV6', e)
  window.dispatchEvent(new CustomEvent('updateUserConfig--v6Config', { detail: e.detail }))
})
